/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_LintInputs */

const en_rd_fix_lint = /** @type {(inputs: Rd_Fix_LintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit an ESLint, Biome, Prettier or Ruff config so agent output matches your style.`)
};

const id_rd_fix_lint = /** @type {(inputs: Rd_Fix_LintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit konfigurasi ESLint, Biome, Prettier, atau Ruff supaya hasil agent seragam dengan gayamu.`)
};

/**
* | output |
* | --- |
* | "Commit an ESLint, Biome, Prettier or Ruff config so agent output matches your style." |
*
* @param {Rd_Fix_LintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_lint = /** @type {((inputs?: Rd_Fix_LintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_LintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_lint(inputs)
	return en_rd_fix_lint(inputs)
});